export const kidsIncentiveBannerSupportedPaths = [
  '/kids',
  '/client/kids',
  '/t/kids',
];
